import { render, staticRenderFns } from "./HighlightedPosts.vue?vue&type=template&id=925b1488&scoped=true&"
import script from "./HighlightedPosts.vue?vue&type=script&lang=js&"
export * from "./HighlightedPosts.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedPosts.vue?vue&type=style&index=0&id=925b1488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925b1488",
  null
  
)

export default component.exports